function _(t,e,o){e.exports="undefined"!=typeof Map&&"[object Map]"===Object.prototype.toString.call(new Map)}
//# sourceMappingURL=is-native-implemented.min.js.map